import { createSelector } from 'reselect';
import type { ClientReducerState } from 'client/reducers';

export const selectCard = (state: ClientReducerState) => state.card;

export const selectCardId = createSelector(selectCard, card => card._id);

export const selectCardElements = createSelector(selectCard, card => card.elements);
